import React, { useContext, useEffect, useState } from 'react';
import { Table } from 'reactstrap';
import { SpinnerButton } from 'common/SpinnerButton';
import { FlashMessageContext } from 'contexts/FlashMessageContext';
import { ListItem } from './ListItem';
import { AuthContext } from 'contexts/AuthContext';
import { updateGeneralSettings } from "utils/api";
import { EditSettingsModal } from "../Modals/EditSettingsModal";

export const List = ({ settings, isLoading, refreshSettings }) => {
    const { addFlashMessage } = useContext(FlashMessageContext);
    const { handleError } = useContext(AuthContext);

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [itemToEdit, setItemToEdit] = useState(null);

    const toggleEditModal = () => setIsEditModalOpen(!isEditModalOpen);

    const handleEditSettings = async (id, value) => {
        try {
            await updateGeneralSettings(id, value);
            addFlashMessage('success', 'Settings successfully changed');
            refreshSettings();
            toggleEditModal();
            setItemToEdit(null);
        } catch (err) {
            handleError(err);
        }
    };

    useEffect(() => {
        itemToEdit && setIsEditModalOpen(true);
    }, [itemToEdit]);

    return (
        <div className="list publication-list">
            {isLoading ?
                <SpinnerButton/>
                :
                <div>
                    {settings?.length < 1 ?
                        <div>
                            No results found
                        </div>
                        :
                        <div>
                            <Table className="responsive-table">
                                <tbody>
                                <tr className="responsive-table header-row">
                                    <th>Settings Name</th>
                                    <th>Settings Value</th>
                                    <th style={{ width: '150px' }}>Actions</th>
                                </tr>

                                {settings.map((item) => (
                                    <ListItem
                                        key={item.id}
                                        item={item}
                                        setItemToEdit={setItemToEdit}
                                    />
                                ))}
                                </tbody>
                            </Table>
                        </div>
                    }
                </div>
            }

            {itemToEdit && <EditSettingsModal isOpen={isEditModalOpen} toggle={toggleEditModal}
                                              handleEditSettings={handleEditSettings} item={itemToEdit}/>}
        </div>
    );
};
